export interface ClientListReturnState {
    returnPathname?: string;
    returnSearch?: string;
    returnState?: unknown;
}

export function getClientListReturnLocation(
    returnState: ClientListReturnState,
    fallback: { pathname: string; search?: string }
) {
    if (!returnState.returnPathname) {
        return fallback;
    }

    return {
        pathname: returnState.returnPathname,
        search: returnState.returnSearch,
        state: returnState.returnState,
    };
}
